import { Time } from "./time";
import { Validateable } from "./interfaces/validateable";

export class PasswordAuth extends Validateable {
	private valid_until: Time = new Time();

	public getValidUntil(): Time {
		return this.valid_until;
	}
}
